import { render, staticRenderFns } from "./PopupMapDesktop.vue?vue&type=template&id=1ad7b3f6&scoped=true&"
import script from "./PopupMapDesktop.vue?vue&type=script&lang=js&"
export * from "./PopupMapDesktop.vue?vue&type=script&lang=js&"
import style0 from "./PopupMapDesktop.vue?vue&type=style&index=0&id=1ad7b3f6&lang=scss&scoped=true&"
import style1 from "./PopupMapDesktop.vue?vue&type=style&index=1&id=1ad7b3f6&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad7b3f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad7b3f6')) {
      api.createRecord('1ad7b3f6', component.options)
    } else {
      api.reload('1ad7b3f6', component.options)
    }
    module.hot.accept("./PopupMapDesktop.vue?vue&type=template&id=1ad7b3f6&scoped=true&", function () {
      api.rerender('1ad7b3f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/PopupMap/components/desktop/PopupMapDesktop.vue"
export default component.exports